export const SETTINGS_PROFILE_INPUT_MAX_LENGTH = 50;
